import { Modal2 } from "./Modal2";
import { observe } from "../reactive";
import ButtonRow from "./ButtonRow";
import { C } from "./constructors";
var cls = C.cls;
export class NisModal extends Modal2 {
    constructor(options = {}) {
        super(options);
        this.options = options;
        this.title = observe("");
        this.title.subscribe(title => {
            this.title_widget?.text(title);
        });
    }
    render() {
        this._content.addClass("nisl-modal");
        this.header = c("<div class='nisl-modal-header'></div>").appendTo(this._content);
        this.body = c("<div class='nisl-modal-body'></div>").appendTo(this._content);
        const buttons = this.getButtons();
        if (this.options.force_footer || buttons.length > 0) {
            this.footer = c("<div class='nisl-modal-footer'></div>").appendTo(this._content);
            if (buttons.length > 0) {
                this.footer.append(new ButtonRow({ align: "center", sizing: "100px", max_center_spacer_width: "100px" })
                    .buttons(...buttons));
            }
        }
        this.title_widget = c("<h1 class='nisl-modal-title'></h1>").text(this.title.value()).appendTo(this.header);
        if (!this.options.disable_close_button) {
            cls('nisl-modal-exit')
                .on("click", () => this.onClose())
                .appendTo(this.header);
        }
    }
    onClose() {
        this.remove();
    }
    setTitle(title) {
        this.title.set(title);
        return this;
    }
    getButtons() {
        return [];
    }
}
(function (NisModal) {
    let active_modals = 0;
})(NisModal || (NisModal = {}));
